import store from '@/store';
import { getBuildedMatfileTemplate } from '@/helpers/matfile';

const PROHIBITION_MATERIALS = [
  {
    name: 'PML-P100 (D100)R',
    articleNumber: '1014226',
  },
  {
    name: 'PML-P100 (D50)R',
    articleNumber: '1014225',
  },
  {
    name: 'US-PML-P100 (D100)',
    articleNumber: '1014218',
  },
  {
    name: 'US-PML-P100 (D50)',
    articleNumber: '1014217',
  },
];

export default () => {
  const { core: { colorSchema } } = store.getState();
  const matfileTemplate = getBuildedMatfileTemplate();

  return PROHIBITION_MATERIALS.some(item => matfileTemplate?.name.includes(item.name) || `${colorSchema?.article_number || ''}` === item.articleNumber);
};
